import { connect } from "react-redux";
import ListWorkflowsComponent from "../../Components/Workflows/ListWorkflowsComponent";
import { setWorkflows } from "../../Redux/Actions/VariablesWorkflowsActions";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
  WORKFLOWS: state.reducer.WORKFLOWS,
});

const mapDispatchToProps = (dispatch) => ({
  setWorkflows: (workflows) => dispatch(setWorkflows(workflows)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListWorkflowsComponent);
